var moment = require('moment');

angular
.module("app.directives")
.directive('datepicker', function($timeout, $filter) {
  return {
    scope: {
      min: "=",
      max: "=",
    },
    require: 'ngModel',
    template: require('./template.pug'),
    replace: true,
    transclude: true,
    link: function DatePickerLink(scope, element, attrs, ngModel) {

      function reset() {
        scope.items = {};
        scope.arr = [];
        scope.selected = null;
      }

      reset();

      ngModel.$render = function() {

        var str = ngModel.$viewValue;
        var reg = new RegExp(/^\d{4}\-\d{2}\-\d{2}$/);

        if (!str) {
          reset();
          scope.build(moment());
          return;
        }

        if (!reg.test(str)) {
          reset();
          throw new Error("Must ONLY pass YYYY-MM-DD iso string into datepicker");
          return;
        }

        // parse date, set as selected, and build month
        var m = moment.utc(str, 'YYYY-MM-DD');
        scope.selected = m;
        scope.build(m.clone());
      }


      scope.build = function(date) {
        var orig = scope.current ? scope.current.clone() : null;
        var firstDayOfMonth = date.clone().startOf('month');

        scope.current = firstDayOfMonth.clone();
        scope.buildMonth(firstDayOfMonth.clone());

        scope.arr = Object.keys(scope.items).sort().map(function(key) {
          return scope.items[key];
        });

        var el = element[0];

        var days = el.querySelector('.datepicker-days');
        if (orig) {
          var current = el.querySelector('[data-first="' + format(orig) + '"]');
        }

        scope.$$postDigest(function() {
          if (orig && current) {
            angular.element(days).removeClass('transition');
            days.setAttribute('style', 'top: ' + -current.offsetTop + 'px');
          }

          $timeout(function() {
            angular.element(days).addClass('transition');
            var target = el.querySelector('[data-first="' + format(firstDayOfMonth) + '"]');
            days.setAttribute('style', 'top: ' + -target.offsetTop + 'px');
          }, 10);
        });
      };

      scope.buildMonth = function(d) {
        // var month = d.month();
        var firstDayOfMonth = d.clone().startOf('month');
        var lastDayOfMonth = d.clone().endOf('month');
        var daysInMonth = d.daysInMonth();

        var dayOfWeek = firstDayOfMonth.day();
        if (dayOfWeek == 0) dayOfWeek = 7;
        firstDayOfMonth.subtract(dayOfWeek, 'days');

        for (var n = 1; n <= 42; n++) {
          var dd = firstDayOfMonth.add(1, 'days').clone();
          scope.items[format(dd)] = dd;
        }
      };

      function format(d) {
        if (!d) return;
        return d.format('YYYY-MM-DD');
      }

      scope.format = format;

      scope.endOfMonth = function(d) {
        return moment(d).endOf('month');
      }

      scope.setupClasses = function(item, selected) {
        var selectedSingle = false;

        if (selected) {
          selectedSingle = format(selected) == format(item);
        }

        var isBetween = item.isBetween(moment.utc(scope.min, 'YYYY-MM-DD').add(-1, 'day'), moment.utc(scope.max, 'YYYY-MM-DD').add(1, 'day'))

        return {
          'selected': selectedSingle,
          'even': item.month() % 2 === 0,
          'disabled': !isBetween,
          'today': format(item) == format(moment())
        };
      };


      scope.back = function($event) {
        $event.target.blur();
        $event.preventDefault();
        var d = scope.current.clone();
        d.subtract(1, 'month');
        scope.build(d);
      };

      scope.forward = function($event) {
        $event.target.blur();
        $event.preventDefault();
        var d = scope.current.clone();
        d.add(1, 'month');
        scope.build(d);
      };

      scope.onSelect = function($event, item) {
        $event.preventDefault();
        scope.selectItem(item);
      };

      scope.selectItem = function(item) {
        ngModel.$setViewValue(format(item));
        ngModel.$render();
      };



    }
  };
});
